import React from 'react';
import { PROXY_APPROVED } from '../../../constants/textConstants';
import SectionLoading from "../../common/SectionLoading";
import SuccessMsg from "../home/SuccessMsg";

const AcceptGrantMsg = ({
    referrer,
    actionType,
    emailProxyRequestIdExists,
    isApprovePending,
    approvedRequestSuccess,
    approvedRequest
}) => {

    const name = approvedRequest
        ? approvedRequest?.LastName
            ? `${approvedRequest.FirstName} ${approvedRequest.LastName}'s`
            : `${approvedRequest.FirstName}'s`
        : 'this'; 

    return (referrer && referrer === 'acceptgrant' &&
        (actionType === PROXY_APPROVED || emailProxyRequestIdExists) &&
        (isApprovePending
            ? <SectionLoading />
            : approvedRequestSuccess
                ? <SuccessMsg
                    message={`You now have access to ${name} account.`}
                />
                : ''
        )
    );
}

export default AcceptGrantMsg;
